import React from 'react';

interface Props {
  color?: string;
  size?: number;
}

/**
 * プライバシーポリシーアイコン（シールド＋チェックマーク）
 * 元SVG: 求人詳細.svg
 * 元SVG offset (-30, -1228) を M 座標に適用済み
 * viewBox: 0 0 12 15
 */
const PrivacyPolicyIcon: React.FC<Props> = ({ color = 'currentColor', size = 24 }) => (
  <svg
    viewBox="0 0 12 15"
    width={size}
    height={size}
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      fill={color}
      fillRule="evenodd"
      d="M6.15,0.97l5.65,2.81c.14.07.2.19.2.32-.17,2.52-.82,4.56-1.82,6.21-1,1.65-2.38,2.93-4,3.9-.12.07-.26.05-.37-.02-1.62-.95-2.98-2.23-4-3.88-1-1.65-1.65-3.69-1.8-6.21-.02-.14.07-.27.2-.34l5.63-2.79c.1-.05.22-.05.31,0h0ZM3.17,7.27c-.12-.14-.1-.36.05-.49.14-.12.36-.1.49.03l1.48,1.74,3.69-3.37c.14-.12.36-.12.49.03.12.14.12.36-.03.49l-3.97,3.61c-.14.14-.36.12-.49-.03l-1.72-2.01Z"
    />
  </svg>
);

export default PrivacyPolicyIcon;
